import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '../../CommonComponents/OPL/Box/Box';
import { Text } from '../../CommonComponents/OPL/Text/Text';
import { selectHasMobileNavigation } from '../../CommonSelectors/CommonAreaSelector';
import { useIsPdf } from '../hooks/useIsPdf';
import { GoalsList } from './components/GoalsList/GoalsList';
import { HeaderActions } from './components/HeaderActions/HeaderActions';
import { HighlightGoals } from './components/HighlightGoals/HighlightGoals';
import { PDFTitle } from '../../PDFRenderer/components/PDFTitle/PDFTitle';

interface Props {
  title?: string;
  clientId: string;
}

export const GoalsSummary = ({ title = 'Summary', clientId }: Props) => {
  const isPdf = useIsPdf();
  const hasMobileNavigation = useSelector(selectHasMobileNavigation);

  return (
    <Box display="flex" flexDirection="column" height="100%" p={hasMobileNavigation ? '16' : '0'}>
      <PDFTitle title={title} />

      <HighlightGoals />

      {!isPdf && (
        <>
          {!hasMobileNavigation && <HeaderActions clientId={clientId} />}

          <Text as="h1" fontSize="h4" color="neutral.600" fontWeight={600} mb="24">
            Goals
          </Text>
        </>
      )}

      <GoalsList clientId={clientId} />
    </Box>
  );
};
